export default {
  groupData: [],
  searchText: '',
  sortNum: 1,
  sortAsc: true
}
